import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { ROW_TYPES } from '../Properties';
import { PageLink } from '../../links/Links';
import { isPresent } from '../funcs';

export default function accessPointProperty(deviceName, deviceId) {
    return {
        type: ROW_TYPES.FUNCTION,
        title: i18n._(t`Wi-Fi Access Point`),
        hasValue: (data) => isPresent(data?.[deviceName]) && isPresent(data?.[deviceId]),
        mapper: (data) => {
            const { [deviceName]: name, [deviceId]: uuid } = data || {};

            if (!name || !uuid) return undefined;

            return (
                <PageLink target="../access-point-detail" targetName={name} filters={[{ name: 'AccessPoint', uuid }]} />
            );
        },
    };
}
